"use client";

import { memo } from "react";

export const ElapsedTime = memo(function ElapsedTime({ ms }: { ms?: number }) {
  if (!ms || ms <= 0) return null;
  const seconds = ms / 1000;
  const display =
    seconds < 60
      ? `${seconds.toFixed(1)}s`
      : `${Math.floor(seconds / 60)}m ${Math.round(seconds % 60)}s`;
  return (
    <span className="text-[10px] text-gray-400 tabular-nums">[{display}]</span>
  );
});
